import Articles from 'components/Articles';
import ChevronArrow from 'styles/icons/ChevronArrow';
import H4 from 'primitives/Typography/Headings/H4';
import NavLink from 'components/NavLink';
import PlayableArticle from './PlayableArticle';
import ReplayIcon from 'styles/icons/Replay';
import Section from 'components/Section';
import UrlParse from 'url-parse';
import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { fetchInitialRecs as fetchRecsAction } from 'state/Recs/actions';
import { getForYouEnabled } from 'state/Features/selectors';
import { getForYouRecs } from 'state/Recs/selectors';
import { localize } from 'redux-i18n';
import { REC_TYPE } from 'state/Recs/constants';
import { shuffle } from 'lodash-es';
import { STATION_TYPE } from 'constants/stationTypes';
import { THUMB_RES } from 'components/MediaServerImage';

const FORYOU_PAGE_SIZE = 3;

class ForYou extends Component {
  static propTypes = {
    fetchInitialRecs: PropTypes.func.isRequired,
    forYouRecs: PropTypes.array.isRequired,
    itemSelectedLocation: PropTypes.string,
    onHeaderClick: PropTypes.func,
    playedFrom: PropTypes.number.isRequired,
  };

  state = {
    current: 0,
    data: [],
  };

  async componentDidMount() {
    const { forYouEnabled, fetchInitialRecs } = this.props;

    if (forYouEnabled) {
      await fetchInitialRecs();
      this.onRecsChange();
    }
  }

  componentDidUpdate(previousProps) {
    const { forYouRecs: prevRecs } = previousProps;
    const { forYouRecs: newRecs } = this.props;

    if (prevRecs.length !== newRecs.length) {
      this.onRecsChange();
    }
  }

  onRecsChange = () => {
    const state = {
      current: 0,
    };

    const { forYouRecs, itemSelectedLocation, playedFrom } = this.props;

    state.data =
      shuffle(forYouRecs).map(rec => {
        let { content } = rec;

        // if we are getting a merched playlist
        // we need to add some stuff in for compatibility
        if ([REC_TYPE.CURATED, REC_TYPE.N4U].includes(rec.subType) && rec.type === 'DL') {
          content = {
            ...content,
            seedId: content.playlistId,
            seedType: STATION_TYPE.COLLECTION,
            url: new UrlParse(rec.subType === REC_TYPE.N4U ? content.webLink : content.contentLink)
              .pathname,
          };
        }
        const imgPath =
          content?.seedType === STATION_TYPE.FAVORITES ? content.imgUrl : rec.imagePath;
        return {
          catalogId: content.seedId,
          catalogType: content.seedType,
          ...(![REC_TYPE.CURATED, REC_TYPE.N4U].includes(rec.subType) && { id: content.seedId }),
          imgUrl: imgPath,
          imgWidth: THUMB_RES,
          itemSelected: itemSelectedLocation
            ? {
                id: content.seedId,
                location: itemSelectedLocation,
                name: content.name || rec.label,
                type: content.seedType,
              }
            : undefined,
          key: [content.seedType, content.seedId].join('|'),
          ownerId: content.ownerId,
          playedFrom,
          title: content.name || rec.label,
          url: content.url,
        };
      }) || [];

    this.setState(state);
  };

  onHeaderClick = () => {
    if (typeof this.props.onHeaderClick === 'function') {
      this.props.onHeaderClick();
    }
    return true;
  };

  refreshRecs = () => {
    let current;

    current = this.state.current + FORYOU_PAGE_SIZE;

    if (current + FORYOU_PAGE_SIZE > this.state.data.length) {
      current = 0;
    }

    this.setState({
      current,
    });
  };

  render() {
    const { forYouEnabled, translate } = this.props;
    if (!forYouEnabled) return null;

    const recs = this.state.data.slice(this.state.current, this.state.current + FORYOU_PAGE_SIZE);

    const header = (
      <div style={{ marginBottom: '2rem' }}>
        {/* H4 as h2 for accessibility. This puts elements in sequentially decending order */}
        <H4 as="h2" style={{ display: 'block' }}>
          <NavLink
            dataTest="foryou-button"
            onClick={this.onHeaderClick}
            rel="nofollow"
            title={translate('iHeart')}
            to="/for-you/"
          >
            {translate('For You')}
          </NavLink>
          <ChevronArrow css={{ margin: '0 0 -2px 5px' }} />
          <div
            data-test="for-you-refresh"
            onClick={this.refreshRecs}
            style={{ cursor: 'pointer', float: 'right', marginTop: '.5rem' }}
          >
            <ReplayIcon />
          </div>
        </H4>
      </div>
    );
    return (
      <Section dataTest="for-you" header={header}>
        <Articles articleClass={PlayableArticle} data={recs} playedFrom={this.props.playedFrom} />
      </Section>
    );
  }
}

export default compose(
  localize('translate'),
  connect(
    createStructuredSelector({
      forYouEnabled: getForYouEnabled,
      forYouRecs: getForYouRecs,
    }),
    { fetchInitialRecs: fetchRecsAction }
  )
)(ForYou);
